module.exports = __webpack_public_path__ + "static/media/maximized.4b5e58e6.svg";